export const addCommas = (amount) => {
    if (typeof amount !== 'number') {
        return "0";
    }
    // Check if the number is negative
    const isNegative = amount < 0;
    // Work with the absolute value of the number for formatting
    let strAmount = Math.abs(amount).toString();

    let formattedIntegerPart = '';
    for (let i = strAmount.length - 1, j = 1; i >= 0; i--, j++) {
        formattedIntegerPart = strAmount[i] + formattedIntegerPart;
        if (j % 3 === 0 && i !== 0) {
            formattedIntegerPart = ',' + formattedIntegerPart;
        }
    }
    // Prepend the negative sign if the original number was negative
    return isNegative ? '-' + formattedIntegerPart : formattedIntegerPart;
}